import { createStyles, Grid, IconButton, makeStyles, Typography, Container, Button } from '@material-ui/core'
import { FC, useEffect, useState } from 'react'
import useTranslate from '../i18n/useTranslate'
import Panel from '../component/report/hold/Panel'
import DataTable from '../component/report/hold/DataTable'
import { useSearchHold, HoldKeywordType, DataRowsType } from '../services/um/useSearchHold'
import holdExport from '../component/report/hold/report'

import moment from 'moment'
import useAuthenStore from '../stores/authen/authenStore'
import { setPrefixName } from './../utilities/prefixName'
import { convertDateToFormatEN, convertDateToFormatTH } from '../utilities/date'
import useProjectType from '../services/um/lookups/useProjectType'
import { useQueryParam, StringParam } from 'use-query-params'
import SearchAccordion from '../control/accordion/SearchAccordion'

import GetAppRoundedIcon from '@material-ui/icons/GetAppRounded'
import { useHistory } from 'react-router'
import { FormApi } from 'final-form'

const Hold: FC<{}> = () => {
    const translate = useTranslate()
    const authenStore = useAuthenStore()
    const history = useHistory()
    const lang = translate.languageStore.currentLanguage as 'th' | 'en'
    const classes = useStyles()
    const { dataList, searchHold } = useSearchHold()
    const { projectT } = useProjectType()
    const [data, setData] = useState<DataRowsType[]>([])
    const [record, setRecord] = useState<number>()

    const [keyword, setKeyword] = useQueryParam('keyword', StringParam)
    const [projectType, setProjectType] = useQueryParam('projectType', StringParam)
    const [startDate, setStartDate] = useQueryParam<Date | string>('startDate')
    const [endDate, setEndDate] = useQueryParam<Date | string>('endDate')

    const setSearchParam = (value: HoldKeywordType) => {
        setStartDate(moment(value.startDate).format('YYYY-MM-DD') ?? '')
        setEndDate(moment(value.endDate).format('YYYY-MM-DD') ?? '')
        setKeyword(value.keyword ?? '')
        setProjectType(value.projectType ?? null)
    }

    const initialSearch = {
        keyword: keyword ?? '',
        projectType: projectType ?? null,
        startDate: startDate ?? moment().subtract(1, 'year').format('YYYY-MM-DD'),
        endDate: endDate ?? moment().format('YYYY-MM-DD'),
        userID: authenStore.profile.userId,
    }

    const onBack = () => {
        history.push('/dashboard')
    }
    useEffect(() => {
        if (authenStore.profile.userId) {
            searchHold(initialSearch)
            setSearchParam(initialSearch)
        }
    }, [authenStore.profile.userId])

    useEffect(() => {
        setRecord(dataList.length)
    }, [dataList])

    useEffect(() => {
        const convertData = dataList.map((item) => {
            return {
                id: item.projectID,
                projectNumber: item.projectNumber ?? '-',
                receiveDate: convertDate(item.receiveDate) ?? '-',
                researcherName: setPrefixName(item)[lang] ?? '-',
                degree: item.degree[lang] ?? '-',
                projectNameTH: item.projectName['th'] ?? '-',
                projectNameEN: item.projectName['en'] ?? '-',
                projectType: item.projectType.name[lang] ?? '-',
                faculty: item.facultyName[lang] ?? '-',
                researcherTypeName: item.researcherTypeName[lang] ?? '-',
                countDueDate: item.countDueDate,
            }
        })
        setData(convertData)
    }, [dataList, lang])

    const convertDate = (date: string | null) => {
        if (lang === 'th' && date) {
            return convertDateToFormatTH(date)
        } else if (lang === 'en' && date) {
            return convertDateToFormatEN(date)
        } else {
            return '-'
        }
    }

    const onSubmit = async (value: HoldKeywordType) => {
        const param = {
            keyword: value.keyword,
            projectType: value.projectType,
            startDate: moment(value.startDate).format('YYYY-MM-DD'),
            endDate: moment(value.endDate).format('YYYY-MM-DD'),
            userID: authenStore.profile.userId,
        }
        setSearchParam(value)
        searchHold(param)
    }

    const getProjectTypeName = (value?: string | null) => {
        let result = null
        if (value) {
            result = projectT.find((item) => item.value === projectType)?.label
        }
        return result ?? '-'
    }

    const onReset = (form: FormApi<HoldKeywordType, Partial<HoldKeywordType>>) => {
        const param = {
            startDate: moment().subtract(1, 'year').format('YYYY-MM-DD'),
            endDate: moment().format('YYYY-MM-DD'),
            userID: authenStore.profile.userId,
        }

        form.initialize(param)
        setSearchParam(param)
    }

    const handleExportExcel = () => {
        data &&
            holdExport({
                header: {
                    projectType: getProjectTypeName(projectType),
                    startDate: convertDate(startDate.toString()),
                    endDate: convertDate(endDate.toString()),
                    keyword: keyword ?? '-',
                },
                content: data,
                translate: (value: string) => translate.get(value),
            })
    }

    return (
        <Container maxWidth="lg">
            <Grid className={classes.root}>
                <SearchAccordion title={translate.get('UM.HOLD.HEADER')} isBack={true} onClickBack={onBack}>
                    <Panel onSubmit={onSubmit} initialSearch={initialSearch} onReset={onReset} />
                </SearchAccordion>
                <Grid container justify="space-between" alignItems="center" className={classes.container}>
                    <Grid item xs={12} md={6}>
                        <Typography variant="h6">
                            {translate.get('LABEL.SEARCH_TOTAL_RESULT', [`${record}`])}
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Grid container justify="flex-end" spacing={2}>
                            <Grid item>
                                <Button
                                    size="large"
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<GetAppRoundedIcon style={{ color: '#DB5F8E' }} />}
                                    onClick={handleExportExcel}
                                >
                                    <Typography variant="button">{translate.get('BUTTON.EXPORT')}</Typography>
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12}>
                        <DataTable dataList={data} />
                    </Grid>
                </Grid>
            </Grid>
        </Container>
    )
}

export default Hold

const useStyles = makeStyles(() => ({
    root: {
        width: '100%',
    },
    container: {
        margin: '15px 0px',
        width: '100%',
    },
}))
